<template>
  <div>
    <p>
      Thruster axis in the satellite frame. It represents the direction to which
      points the propulsive system in the spacecraft.
    </p>
    <p>
      This axis is aligned to the instantaneous thrust direction during a
      manoeuvre (if the satellite's attitude and power system are simulated),
      and it is opposite to the acceleration of the spacecraft generated by the
      thrust.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipPropulsionSystemDirection'
}
</script>
